import { ReactElement, useMemo } from 'react';
import { Stack, DialogContentText, Link, Button } from '@mui/material';

import { useAppSelector } from '~hooks/useAppSelector';
import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { selectAuth } from '~store/slices/auth';
import { isAdminUser } from '~utils/user';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

// eslint-disable-next-line max-len
import { useDialogImportOrdersFromIntegrationContext } from '../../DialogImportOrdersFromIntegrationContext';
import { DialogImportOrdersFromIntegrationLabelImg } from '../../styles';

const DialogImportOrdersFromIntegrationNotIntegrations = (): ReactElement => {
  const { user } = useAppSelector(selectAuth);
  const { isCarrier } = useTypePartnerCompany();

  const isAdmin = useMemo(() => isAdminUser(user), [user]);

  const { handleEmtpy } = useDialogImportOrdersFromIntegrationContext();

  return (
    <Stack spacing={2} flex={1} justifyContent="space-between">
      <Stack spacing={2} justifyContent="center" alignItems="center">
        <DialogImportOrdersFromIntegrationLabelImg
          src={toAbsoluteUrl('/images/not_import_int.png')}
          alt="Not import integrations"
          size="large"
        />
        <DialogContentText fontSize={22} fontWeight="bold" color="text.primary">
          CARGA DIRECTAMENTE DESDE TUS TIENDAS
        </DialogContentText>
        <DialogContentText
          color="text.primary"
          textAlign="center"
          sx={{ paddingX: 10 }}
        >
          Facilitamos la tarea de importación de tus tiendas favorítas. Podrás
          asociar tus tiendas o las de tus dadores de carga y vendedores.
        </DialogContentText>

        <Button
          variant="contained"
          color="primary"
          onClick={handleEmtpy}
          disabled={!isAdmin}
        >
          {isAdmin
            ? 'Integra tus tiendas'
            : 'Solicita a un administrador que integre tus tiendas'}
        </Button>
      </Stack>

      <DialogContentText
        variant="caption"
        // @NEW-GIVER-DASHBOARD: Hide until the help URL is available for Givers
        visibility={isCarrier ? 'visible' : 'hidden'}
      >
        Para mayor información sobre integraciones, diríjase a este{' '}
        <Link
          href="https://routix.tawk.help/article/integraciones-con-otras-plataformas"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
          underline="hover"
          fontWeight="bold"
        >
          artículo
        </Link>
      </DialogContentText>
    </Stack>
  );
};

export default DialogImportOrdersFromIntegrationNotIntegrations;
